module.exports = __webpack_public_path__ + "static/media/addyPic1.f511e58f.jpg";